import React from "react";
import { useCommonContext } from "@/src/provider";
import { youTuBeVideoWH } from "@/lib/commonService";
import stl from "./pdHelp.module.scss";
import classnames from "classnames";
import { useTranslation } from "@/src/i18n/client";
interface IProps {}
const PDHelp: React.FC<IProps> = (props) => {
    const { site } = useCommonContext();
    const { t } = useTranslation("lens");

    return (
        <div className={stl["pd-iframe-container"]}>
            {site != "fm" && (
                <iframe
                    onLoad={(e) => {
                        youTuBeVideoWH(e.target, 560 / 315);
                    }}
                    className={stl["pd-iframe"]}
                    width="560"
                    height="315"
                    src="https://www.youtube.com/embed/KpcN94kf5j0"
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            )}
            <div
                className={classnames(
                    stl["rx-form-help-title"],
                    "form-help-title",
                )}
            >
                {t("lens:Explain.PupillaryDistance")}
            </div>
            <p className={stl["rx-form-hlep-p"]}>{t("lens:Explain.PD")}</p>
            <p
                className={stl["rx-form-hlep-p"]}
                style={{ margin: "0.3rem 0 0" }}
            >
                <a href={t("lens:PDRuler")} download="PD Ruler.pdf">
                    {t("lens:Explain.DOWNLOAD_A_PRINTABLE_PD_RULER")}
                </a>
            </p>
        </div>
    );
};

export default PDHelp;
